import { ComponentsProps, ComponentsOverrides, ComponentsVariants, badgeClasses } from '@mui/material';
import { Theme } from '@mui/system/createTheme';

export const MuiBadge: {
    defaultProps?: ComponentsProps['MuiBadge'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiBadge'];
    variants?: ComponentsVariants['MuiBadge'];
} = {
    styleOverrides: {
        badge: {
            [`&.${badgeClasses.anchorOriginTopRight}`]: {
                transform: 'scale(1) translate(100%, -50%)',
                [`&.${badgeClasses.invisible}`]: {
                    transform: 'scale(0) translate(50%, -50%);',
                },
            },
        },
    },
};
